import { styled } from 'styled-components';

import { ThemeMode } from '@/helpers/enums';

import { device, hexToRGB, typography } from '@/styles/helpers';

export const ScDepositModal = styled.div<{ gap?: number }>`
  position: relative;
  background: ${({ theme }) => theme.whiteColor};
  color: ${({ theme }) => theme.blackColor};
  overflow: hidden;
  width: 100%;

  max-width: 640px;
  min-height: 420px;
  border-radius: 24px;
  padding: 16px;
  margin: 40px auto;
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => `${gap}px`};

  & > header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;

    .currency-icon {
      color: ${({ theme }) => theme.blackColor};
    }
  }
`;

export const ScDepositSection = styled.div<{ mode?: ThemeMode }>`
  display: flex;
  flex-direction: column;
  gap: 16px;

  & > .title {
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.44px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 8px;

    @media (${device.mobile}) {
      font-size: 20px;
      line-height: 26px;
    }

    .tag {
      display: flex;
      flex-shrink: 0;
      padding: 2px 12px;
      border-radius: 20px;
      background-color: ${({ theme, mode }) =>
        mode === ThemeMode.Dark ? theme.grayDarkColor : theme.gray1Color};
      ${typography.body2bold}
      text-transform: initial;
    }
  }

  & > .list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  input::placeholder {
    text-align: start;
  }
`;

export const ScNotFound = styled.div`
  padding: 16px 24px;
  border-radius: 8px;

  color: ${({ theme }) => theme.blackColor};
  background-color: ${({ theme }) => hexToRGB(theme.yellowColor, 0.2)};

  ${typography.body2regular}
`;
